(() => {
  const BANNER_SELECTOR = '#shopify-pc__banner, section#shopify-pc__banner';
  const ACCEPT_SELECTOR = [
    '#shopify-pc__banner__btn-accept',
    '.shopify-pc__banner__btn-accept',
    'button[data-purpose="accept"]',
    'button[id*="btn-accept"]',
  ].join(',');
  const DECLINE_SELECTOR = [
    '#shopify-pc__banner__btn-decline',
    '.shopify-pc__banner__btn-decline',
    'button[data-purpose="decline"]',
    'button[id*="btn-decline"]',
  ].join(',');

  const getBanner = (element) => element?.closest?.(BANNER_SELECTOR) || document.querySelector(BANNER_SELECTOR);

  const hideBanner = (banner) => {
    if (!banner) return;
    banner.setAttribute('aria-hidden', 'true');
    banner.hidden = true;
    banner.style.setProperty('display', 'none', 'important');
    document.documentElement.classList.remove('shopify-pc__banner-open');
    document.body?.classList.remove('shopify-pc__banner-open');
  };

  const loadCustomerPrivacy = (callback) => {
    const readyApi = window.Shopify?.customerPrivacy;
    if (readyApi?.setTrackingConsent) {
      callback(readyApi);
      return;
    }

    if (!window.Shopify?.loadFeatures) {
      callback(null);
      return;
    }

    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      (error) => callback(error ? null : window.Shopify?.customerPrivacy || null),
    );
  };

  const setConsent = (accepted, banner) => {
    if (!banner || banner.dataset.azulConsentSubmitting === 'true') return;
    banner.dataset.azulConsentSubmitting = 'true';

    loadCustomerPrivacy((api) => {
      if (!api?.setTrackingConsent) {
        delete banner.dataset.azulConsentSubmitting;
        return;
      }

      let finished = false;
      const finish = () => {
        if (finished) return;
        finished = true;
        hideBanner(banner);
      };

      const consent = {
        analytics: accepted,
        marketing: accepted,
        preferences: accepted,
      };

      try {
        api.setTrackingConsent(consent, finish);
      } catch (error) {
        try {
          // Compatibility fallback for older storefront API versions.
          api.setTrackingConsent(Boolean(accepted), finish);
        } catch (legacyError) {
          delete banner.dataset.azulConsentSubmitting;
          return;
        }
      }

      // The Shopify API normally invokes the callback. This timeout only closes
      // the already-submitted banner if an embedded preview suppresses it.
      window.setTimeout(finish, 1800);
    });
  };

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const button = target?.closest('button');
      if (!button) return;

      const banner = getBanner(button);
      if (!banner) return;

      if (button.matches(ACCEPT_SELECTOR)) {
        // Let Shopify's own handler run too; this is a reliable API fallback.
        window.setTimeout(() => setConsent(true, banner), 0);
      } else if (button.matches(DECLINE_SELECTOR)) {
        window.setTimeout(() => setConsent(false, banner), 0);
      }
    },
    true,
  );
})();
